import * as Request from '../Request';

const Log = {
  // 短信日志分页列表
  smsLogList: (data) => {
    return Request.post('/tenant/expire/sms/log/list', data);
  },
  // 接口日志分页列表
  apiLogList: (data) => {
    return Request.post('/api/log/list', data);
  }
}
export default Log
